<section id="faq" class="faq">
  <div class="faq-inner">
    <div class="faq-head">
      <div ppcEyebrow mark>{{ 'faqSection.eyebrow' | translate }}</div>
      <h2 ppcHeading class="faq-title">{{ 'faqSection.title' | translate }}</h2>
    </div>

    <div class="faq-list">
      @for (entry of entries(); track $index) {
        <div class="faq-item">
          <button type="button" class="faq-row" (click)="toggle($index)">
            <span class="faq-number">{{ entry.number }}</span>
            <span class="faq-question">{{ entry.question }}</span>
            <span class="faq-sign">{{ entry.sign }}</span>
          </button>
          <div class="faq-answer" [class.is-open]="entry.isOpen">
            <div class="faq-answer-inner">{{ entry.answer }}</div>
          </div>
        </div>
      }
    </div>
  </div>
</section>
